<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>{{'main.nav.links.report.system.fullLabel' | translate}}</h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <mat-form-field class="report-selector">
            <mat-label>{{'main.nav.links.report.report.shortLabel' | translate}}</mat-label>
            <mat-select [(value)]="selectedReport">
                <mat-option *ngFor="let reportCode of reportCodes" [value]="reportCode">{{ reportCode.label }}</mat-option>
            </mat-select>
        </mat-form-field>
        <button mat-raised-button color="accent" [disabled]="isGenerating || !selectedReport" (click)="onExportReport()">
            <mat-icon aria-label="File">insert_drive_file</mat-icon> {{'users.licenceBilling.submit.shortLabel' | translate}}
        </button>
        <mat-spinner *ngIf="isGenerating" [diameter]="35" color="accent" ></mat-spinner>
        <br />
        <mat-form-field class="report-selector" *ngFor="let parameter of selectedReport.parameters">
            <mat-label>{{ parameter.label }}</mat-label>
            <mat-select [(value)]="parameter.selectedValue.code">
                <mat-option *ngFor="let value of parameter.values" [value]="value.code">{{ value.label }}</mat-option>
            </mat-select>
        </mat-form-field>
    </mat-card-content>
</mat-card>
